export default __webpack_public_path__ + "static/media/bitrix24.8de89c2b.png";